import { createClientComponentClient } from '@/integrations/supabase/client'

// THE single community-clone insert. Called by: createClass's community branch
// (EducationAdminPage), the /learn door, and ParentDashboard. Never fork this —
// origin semantics live here: 'teacher_created' + source_class_id stamped +
// starts unpublished ('community' is a request discriminator, NEVER a row value).
export async function cloneCommunityCourse(
  sourceClassId: string,
  caller: { teacherId: string; facilityId: string },
  className?: string
): Promise<{ classId?: string; error?: string }> {
  const supabase = createClientComponentClient()

  const { data: src, error: fetchErr } = await (supabase
    .from('community_course_library' as any) as any)
    .select('name, description, target_age, subject_group, category_id, module_plan, essay_mode, curriculum_track')
    .eq('id', sourceClassId)
    .maybeSingle()
  if (fetchErr) return { error: fetchErr.message }
  if (!src) return { error: 'Course not found or no longer published.' }
  if (!Array.isArray(src.module_plan) || src.module_plan.length === 0) {
    return { error: 'Source course has no module plan yet — try again shortly.' }
  }

  const { data: inserted, error: insertErr } = await (supabase.from('classes') as any).insert({
    name: className?.trim() || src.name,
    description: src.description,
    target_age: src.target_age,
    subject_group: src.subject_group,
    category_id: src.category_id,
    teacher_id: caller.teacherId,
    facility_id: caller.facilityId,
    module_plan: src.module_plan,
    essay_mode: src.essay_mode,
    curriculum_track: src.curriculum_track,
    knowledge_context: null, // community clones never inherit org-private context (04 hardening)
    source_class_id: sourceClassId,
    origin: 'teacher_created',
    is_community_published: false,
    is_active: true,
  }).select('id').single()
  if (insertErr) return { error: insertErr.message }

  // Deep-copy lesson media & concept photos into the new class
  try {
    await supabase.rpc('copy_class_lesson_media', {
      p_source_class_id: sourceClassId,
      p_target_class_id: inserted.id,
    })
  } catch (err) {
    console.warn('[cloneCommunityCourse] Failed to copy lesson media:', err)
  }

  return { classId: inserted.id }
}

export async function copyClassLessonMedia(
  sourceClassId: string,
  targetClassId: string
): Promise<number> {
  const supabase = createClientComponentClient()
  const { data, error } = await supabase.rpc('copy_class_lesson_media', {
    p_source_class_id: sourceClassId,
    p_target_class_id: targetClassId,
  })
  if (error) {
    console.warn('[copyClassLessonMedia] Error copying media:', error.message)
    return 0
  }
  return Number(data) || 0
}
